module.exports = __webpack_public_path__ + "img/logo_avpn.5ad5f221.jpg";